import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Sun, Moon as MoonIcon, AlertTriangle, Sparkles } from "lucide-react";
import CitySearchInput from "@/components/CitySearchInput";

export default function PanchangCard() {
  const [data, setData] = useState(null);
  const [place, setPlace] = useState("New Delhi");
  const [query, setQuery] = useState("New Delhi");

  useEffect(() => {
    api.get("/panchang", { params: { place } }).then(r => setData(r.data)).catch(() => {});
  }, [place]);

  return (
    <Card className="p-5 rounded-2xl border-slate-200 dark:border-slate-800 bg-gradient-to-br from-white to-amber-50/30 dark:from-slate-900/60 dark:to-amber-500/5" data-testid="panchang-card">
      <div className="flex items-center justify-between mb-3 gap-3">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.25em] text-amber-600 dark:text-amber-400">Today's Panchang</div>
          <div className="font-display text-xl mt-0.5 truncate">{data?.date || "—"} · {data?.weekday || ""}</div>
        </div>
        <div className="w-56 shrink-0">
          <CitySearchInput
            value={query}
            onChange={setQuery}
            onSelect={(c) => { setQuery(c.label); setPlace(c.name); }}
            placeholder="City"
            testid="panchang-place"
          />
        </div>
      </div>

      {data && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <PItem label="Tithi" value={data.tithi.name} sub={`${data.tithi.progress_pct}% elapsed`} />
            <PItem label="Nakshatra" value={data.nakshatra.name} sub={`Lord: ${data.nakshatra.lord}`} />
            <PItem label="Yoga" value={data.yoga} />
            <PItem label="Karana" value={data.karana} />
          </div>
          <div className="mt-3 pt-3 border-t border-slate-200 dark:border-slate-800 grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
            <div className="flex items-center gap-1.5"><Sun className="w-3.5 h-3.5 text-amber-500" /><span className="text-slate-500">Sunrise</span> <span className="font-mono font-semibold">{data.sunrise}</span></div>
            <div className="flex items-center gap-1.5"><MoonIcon className="w-3.5 h-3.5 text-slate-500" /><span className="text-slate-500">Sunset</span> <span className="font-mono font-semibold">{data.sunset}</span></div>
            {data.rahukalam && (
              <div className="flex items-center gap-1.5"><AlertTriangle className="w-3.5 h-3.5 text-red-500" /><span className="text-slate-500">Rahukalam</span> <span className="font-mono text-red-600 font-semibold">{data.rahukalam.start}–{data.rahukalam.end}</span></div>
            )}
            {data.abhijit_muhurat && (
              <div className="flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5 text-emerald-500" /><span className="text-slate-500">Abhijit</span> <span className="font-mono text-emerald-700 dark:text-emerald-400 font-semibold">{data.abhijit_muhurat.start}–{data.abhijit_muhurat.end}</span></div>
            )}
          </div>
        </>
      )}
    </Card>
  );
}

const PItem = ({ label, value, sub }) => (
  <div className="rounded-xl p-3 bg-white/70 dark:bg-slate-900/40 border border-slate-200 dark:border-slate-800">
    <div className="text-[9px] uppercase tracking-widest text-slate-500">{label}</div>
    <div className="font-display text-base leading-tight">{value}</div>
    {sub && <div className="text-[10px] text-slate-500 mt-0.5">{sub}</div>}
  </div>
);
